if (!customElements.get('product-description-preview')) {
  customElements.define(
    'product-description-preview',
    class ProductDescriptionPreview extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.content = this.querySelector('.product__description-preview-content');
        this.template = this.querySelector('.product__description-preview-template');
        this.toggle = this.querySelector('.product__description-preview-toggle');
        if (!this.content || !this.template || !this.toggle) return;

        this.initialized = true;
        this.renderDescription();
        this.toggle.addEventListener('click', () => this.toggleDescription());
      }

      renderDescription() {
        const description = this.template.content.cloneNode(true);
        const idMap = new Map();
        const idPrefix = `${this.content.id}-`;

        description.querySelectorAll('[id]').forEach((element) => {
          const originalId = element.id;
          const uniqueId = `${idPrefix}${originalId}`;

          idMap.set(originalId, uniqueId);
          element.id = uniqueId;
        });

        const referenceAttributes = [
          'for',
          'aria-activedescendant',
          'aria-controls',
          'aria-describedby',
          'aria-details',
          'aria-errormessage',
          'aria-flowto',
          'aria-labelledby',
          'aria-owns',
          'headers',
          'list',
        ];

        referenceAttributes.forEach((attribute) => {
          description.querySelectorAll(`[${attribute}]`).forEach((element) => {
            const references = element.getAttribute(attribute).split(/\s+/);
            element.setAttribute(
              attribute,
              references.map((reference) => idMap.get(reference) || reference).join(' ')
            );
          });
        });

        description.querySelectorAll('[href^="#"]').forEach((element) => {
          const reference = element.getAttribute('href').slice(1);
          if (idMap.has(reference)) element.setAttribute('href', `#${idMap.get(reference)}`);
        });

        this.content.appendChild(description);
      }

      toggleDescription() {
        const expanded = this.toggle.getAttribute('aria-expanded') === 'true';

        this.toggle.setAttribute('aria-expanded', String(!expanded));
        this.dataset.expanded = String(!expanded);
      }
    }
  );
}
